<template>
  <div>
    <div v-if="!GS.ShowSettings">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-4"
      >{{LanguageStrings[DisplayLanguage]['headline_read']}}</h1>
      <table>
        <tr>
          <td
            class="tablekey"
            v-bind:style="{ color: Company.CI_Headlinecolor }"
          >{{LanguageStrings[DisplayLanguage]['from']}}:</td>
          <td class="tablevalue" v-bind:style="{ color: Company.CI_Textcolor }">{{Session.From}}</td>
        </tr>
        <tr>
          <td
            class="tablekey"
            v-bind:style="{ color: Company.CI_Headlinecolor }"
          >{{LanguageStrings[DisplayLanguage]['to']}}:</td>
          <td class="tablevalue" v-bind:style="{ color: Company.CI_Textcolor }">{{Session.To}}</td>
        </tr>
        <tr>
          <td
            class="tablekey"
            v-bind:style="{ color: Company.CI_Headlinecolor }"
          >{{LanguageStrings[DisplayLanguage]['subject']}}:</td>
          <td class="tablevalue" v-bind:style="{ color: Company.CI_Textcolor }">{{Session.Subject}}</td>
        </tr>
        <tr>
          <td
            class="tablekey"
            v-bind:style="{ color: Company.CI_Headlinecolor }"
          >{{LanguageStrings[DisplayLanguage]['date']}}:</td>
          <td class="tablevalue" v-bind:style="{ color: Company.CI_Textcolor }">{{Session.SendTime}}</td>
        </tr>
      </table>
      <h2
        v-bind:style="{ color: Company.CI_Headlinecolor }"
      >{{LanguageStrings[DisplayLanguage]['emailtext']}}:</h2>
      <p v-bind:style="{ color: Company.CI_Textcolor }" style="white-space: pre-wrap;">{{Session.Body}}</p>
      <div v-if="Session.Attachments != null && Session.Attachments.length > 0">
        <hr v-bind:style="{ borderTop: '1px solid ' + Company.CI_Hrcolor }" />
        <h2
          v-bind:style="{ color: Company.CI_Headlinecolor }"
        >{{LanguageStrings[DisplayLanguage]['attachments']}}:</h2>
        <ul>
          <li
            v-bind:style="{ color: Company.CI_Attachmentcolor }"
            v-for="(attachment,index) in Session.Attachments"
            v-bind:key="index"
          ><a v-bind:style="{ color: Company.CI_Attachmentcolor, textDecoration: 'none' }" :href="GS.Endpoint + '/v2/download/' + Session.SessionId + '/' + attachment.UID" target="_blank">{{attachment.Name}} ({{humanFileSize(attachment.Length, true)}})</a></li>
        </ul>
      </div>
    </div>
    <SettingsDefault v-if="GS.ShowSettings" />
  </div>
</template>

<script>
import axios from "axios";
import SettingsDefault from './SettingsDefault'

export default {
  name: "ReadDefault",
  components: {
    //HelloWorld
    SettingsDefault
  },
  data: function() {
    return {

    };
  },
  mounted: function() {},
  computed: {},
  methods: {
    //            @click="download(attachment.UID)"
    download: function(attachment) {
      var link = document.createElement("a");
      link.href =
        this.GS.Endpoint +
        "/v2/download/" +
        this.Session.SessionId +
        "/" +
        attachment;
      link.click();
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
input {
  font-size: 13px;
}
ul {
  margin-left: 20px;
}
p {
  margin-top: 5px;
  margin-bottom: 5px;
}
td {
  padding-bottom: 7px;
}
li {
  margin-bottom: 7px;
  font-weight: bold;
  cursor: pointer;
}

.tablekey {
  font-weight: bold;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  margin: 1em 0;
  padding: 0;
  margin-top: 20px;
}
.tablevalue {
  padding-left: 10px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

</style>
